import React from "react";

// 챗 카드 컴포넌트
const ChatCard = ({ children, isUser, agent, color }) => (
  <div
    className={`flex items-center mb-2.5 ${
      !isUser ? "justify-start" : "justify-end"
    }`}
  >
    <div
      className={`inline-block py-3.5 px-6 mx-5 text-neutral-600 font-medium border ${
        !agent
          ? !isUser
            ? `border-${color} bg-white rounded-custom-reverse`
            : "border-neutral-400 bg-neutral-50 rounded-custom"
          : !isUser
            ? "bg-purple-c-50 border-purple-c-900 rounded-custom-reverse"
            : "border-neutral-400 bg-neutral-50 rounded-custom !mx-0"
      }`}
    >
      {children}
    </div>
  </div>
);

export default ChatCard;
